import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ImagePreviewController extends Controller {
  static targets = ['image', 'placeholder', 'input']
  static values = {
    originalUrl: String
  }

  preview () {
    const [file] = this.inputTarget.files

    if (!file) {
      this.#reset()
      return
    }

    const reader = new FileReader()

    reader.addEventListener('load', () => {
      this.imageTarget.src = reader.result
      this.imageTarget.classList.remove('hidden')
      this.placeholderTarget.classList.add('hidden')
    })

    reader.readAsDataURL(file)
  }

  #reset () {
    if (this.hasOriginalUrlValue && this.originalUrlValue.length > 0) {
      this.imageTarget.src = this.originalUrlValue
      this.imageTarget.classList.remove('hidden')
      this.placeholderTarget.classList.add('hidden')
      return
    }

    this.imageTarget.removeAttribute('src')
    this.imageTarget.classList.add('hidden')
    this.placeholderTarget.classList.remove('hidden')
  }
}

stimulus.register('image-preview', ImagePreviewController)
